import { render } from "./HorizontalLinks.vue?vue&type=template&id=18229a45&scoped=true"
import script from "./HorizontalLinks.vue?vue&type=script&lang=js"
export * from "./HorizontalLinks.vue?vue&type=script&lang=js"

import "./HorizontalLinks.vue?vue&type=style&index=0&id=18229a45&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18229a45"]])

export default __exports__